import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=1de88286&scoped=true&"
import script from "./AppForm.vue?vue&type=script&lang=js&"
export * from "./AppForm.vue?vue&type=script&lang=js&"
import style0 from "./AppForm.vue?vue&type=style&index=0&id=1de88286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de88286",
  null
  
)

export default component.exports